// // pages/InviteUserPage.jsx
// import React, { useState, useEffect } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import { FaArrowLeft } from 'react-icons/fa';
// import { UserPlus, Mail, Phone, Building, Briefcase, MapPin, Calendar, Camera } from 'lucide-react';
// import api from '../../common/apiClient';
// import SummaryApi from '../../common/SummaryApi';

// const InviteUserForm = () => {
//   const navigate = useNavigate();
//   const { portalName } = useParams();
  
//   const [formData, setFormData] = useState({
//     email: '',
//     firstName: '',
//     lastName: '',
//     mobile: '',
//     dob: '',
//     doj: '',
//     customRoleId: '',
//     departmentId: '',
//     divisionId: '',
//     profilePicture: null,
//     address: {
//       street: '',
//       city: '',
//       state: '',
//       country: '',
//       zipCode: ''
//     }
//   });
  
//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [previewImage, setPreviewImage] = useState(null);
  
//   // Dropdown data
//   const [roles, setRoles] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Fetch dropdown data on mount
//   useEffect(() => {
//     fetchDropdownData();
//   }, []);

//   const fetchDropdownData = async () => {
//     try {
//       const [rolesRes, departmentsRes, divisionsRes] = await Promise.all([
//         api.get(SummaryApi.getAllRoles.url),
//         api.get(SummaryApi.getAllDepartments.url),
//         api.get(SummaryApi.getAllDivisions.url)
//       ]);

//       setRoles(rolesRes.data.data || []);
//       setDepartments(departmentsRes.data.data || []);
//       setDivisions(divisionsRes.data.data || []);
//     } catch (error) {
//       console.error('Error fetching dropdown data:', error);
//       toast.error('Failed to load form data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Form validation
//   const validateForm = () => {
//     const newErrors = {};
    
//     // Required fields
//     if (!formData.email) newErrors.email = 'Email is required';
//     else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
    
//     if (!formData.firstName) newErrors.firstName = 'First name is required';
//     if (!formData.lastName) newErrors.lastName = 'Last name is required';
    
//     if (formData.mobile && !/^\d{10}$/.test(formData.mobile.replace(/\D/g, ''))) {
//       newErrors.mobile = 'Mobile number must be 10 digits';
//     }
    
//     if (!formData.customRoleId) newErrors.customRoleId = 'Role is required';
//     if (!formData.departmentId) newErrors.departmentId = 'Department is required';
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // Handle input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     if (name.startsWith('address.')) {
//       const addressField = name.split('.')[1];
//       setFormData(prev => ({
//         ...prev,
//         address: {
//           ...prev.address,
//           [addressField]: value
//         }
//       }));
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         [name]: value
//       }));
//     }
    
//     // Clear error for this field
//     if (errors[name]) {
//       setErrors(prev => ({ ...prev, [name]: '' }));
//     }
//   };

//   // Handle file upload
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.size > 5 * 1024 * 1024) { // 5MB limit
//         setErrors(prev => ({ ...prev, profilePicture: 'File size must be less than 5MB' }));
//         return;
//       }
      
//       setFormData(prev => ({ ...prev, profilePicture: file }));
      
//       // Create preview
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewImage(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) return;
    
//     setIsSubmitting(true);
    
//     try {
//       const formDataToSend = new FormData();
      
//       // Append all fields
//       Object.keys(formData).forEach(key => {
//         if (key === 'address') {
//           formDataToSend.append(key, JSON.stringify(formData[key]));
//         } else if (key === 'profilePicture' && formData[key]) {
//           formDataToSend.append(key, formData[key]);
//         } else if (formData[key]) {
//           formDataToSend.append(key, formData[key]);
//         }
//       });
      
//       const response = await api.post(SummaryApi.createInvite.url, formDataToSend, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         }
//       });
      
//       if (response.data.success) {
//         toast.success('Invitation sent successfully!');
//         navigate(`/${portalName}/settings/users/invitations`);
//       } else {
//         throw new Error(response.data.message || 'Failed to send invitation');
//       }
//     } catch (error) {
//       setErrors({ submit: error.response?.data?.message || error.message });
//       toast.error(error.response?.data?.message || 'Failed to send invitation');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Reset form
//   const resetForm = () => {
//     setFormData({
//       email: '',
//       firstName: '',
//       lastName: '',
//       mobile: '',
//       dob: '',
//       doj: '',
//       customRoleId: '',
//       departmentId: '',
//       divisionId: '',
//       profilePicture: null,
//       address: {
//         street: '',
//         city: '',
//         state: '',
//         country: '',
//         zipCode: ''
//       }
//     });
//     setPreviewImage(null);
//     setErrors({});
//   };

//   // Filter divisions based on selected department
//   const filteredDivisions = formData.departmentId 
//     ? divisions.filter(div => div.departmentId === formData.departmentId)
//     : divisions;

//   const handleBack = () => {
//     navigate(-1);
//   };

//   const handleCancel = () => {
//     navigate(`/${portalName}/invitations`);
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="">
//       <div className="">
//         {/* Header */}
//         <div className="mb-8">
//           <div className="flex items-center gap-4 mb-4">
//             <button
//               onClick={handleBack}
//               className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
//               aria-label="Go back"
//             >
//               <FaArrowLeft className="h-5 w-5" />
//             </button>
//             <div className="flex-1">
//               <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-3">
//                 <div className="bg-gradient-to-r from-red-500 to-pink-500 p-3 rounded-lg text-white">
//                   <UserPlus className="h-6 w-6" />
//                 </div>
//                 Invite Team Member
//               </h1>
//               <p className="text-gray-600 mt-2">Send an invitation to add a new member to your team</p>
//             </div>
//           </div>
//         </div>

//         {/* Form */}
//         <form onSubmit={handleSubmit} className="space-y-6">
//           {errors.submit && (
//             <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg flex items-center">
//               <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//               {errors.submit}
//             </div>
//           )}

//           {/* Basic Information */}
//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//             <div className="flex items-center gap-2 mb-6">
//               <div className="bg-red-100 p-2 rounded-lg">
//                 <Mail className="h-5 w-5 text-red-600" />
//               </div>
//               <h3 className="text-lg font-semibold text-gray-900">Basic Information</h3>
//             </div>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {/* Email */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Email Address <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
//                     errors.email ? 'border-red-500' : 'border-gray-300'
//                   }`}
//                   placeholder="user@example.com"
//                 />
//                 {errors.email && <p className="mt-1 text-sm text-red-500">{errors.email}</p>}
//               </div>

//               {/* Mobile */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Mobile Number
//                 </label>
//                 <div className="relative">
//                   <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
//                   <input
//                     type="tel"
//                     name="mobile"
//                     value={formData.mobile}
//                     onChange={handleChange}
//                     className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
//                       errors.mobile ? 'border-red-500' : 'border-gray-300'
//                     }`}
//                     placeholder="9876543210"
//                   />
//                 </div>
//                 {errors.mobile && <p className="mt-1 text-sm text-red-500">{errors.mobile}</p>}
//               </div>

//               {/* First Name */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   First Name <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleChange}
//                   className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
//                     errors.firstName ? 'border-red-500' : 'border-gray-300'
//                   }`}
//                   placeholder="John"
//                 />
//                 {errors.firstName && <p className="mt-1 text-sm text-red-500">{errors.firstName}</p>}
//               </div>

//               {/* Last Name */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Last Name <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="lastName"
//                   value={formData.lastName}
//                   onChange={handleChange}
//                   className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
//                     errors.lastName ? 'border-red-500' : 'border-gray-300'
//                   }`}
//                   placeholder="Doe"
//                 />
//                 {errors.lastName && <p className="mt-1 text-sm text-red-500">{errors.lastName}</p>}
//               </div>

//               {/* Date of Birth */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Date of Birth
//                 </label>
//                 <div className="relative">
//                   <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
//                   <input
//                     type="date"
//                     name="dob"
//                     value={formData.dob}
//                     onChange={handleChange}
//                     className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//                     max={new Date().toISOString().split('T')[0]}
//                   />
//                 </div>
//               </div>

//               {/* Date of Joining */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Date of Joining
//                 </label>
//                 <div className="relative">
//                   <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
//                   <input
//                     type="date"
//                     name="doj"
//                     value={formData.doj}
//                     onChange={handleChange}
//                     className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Profile Picture */}
//             <div className="mt-6 pt-6 border-t">
//               <label className="block text-sm font-medium text-gray-700 mb-3">
//                 Profile Picture
//               </label>
//               <div className="flex items-center space-x-6">
//                 {previewImage ? (
//                   <img
//                     src={previewImage}
//                     alt="Preview"
//                     className="h-24 w-24 rounded-full object-cover ring-4 ring-red-100"
//                   />
//                 ) : (
//                   <div className="h-24 w-24 rounded-full bg-gradient-to-br from-red-100 to-pink-100 flex items-center justify-center">
//                     <Camera className="h-10 w-10 text-red-400" />
//                   </div>
//                 )}
//                 <div className="flex flex-col gap-2">
//                   <input
//                     type="file"
//                     accept="image/*"
//                     onChange={handleFileChange}
//                     className="hidden"
//                     id="profile-picture"
//                   />
//                   <label
//                     htmlFor="profile-picture"
//                     className="cursor-pointer bg-white px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors inline-flex items-center gap-2"
//                   >
//                     <Camera className="h-4 w-4" />
//                     Choose Photo
//                   </label>
//                   {previewImage && (
//                     <button
//                       type="button"
//                       onClick={() => {
//                         setFormData(prev => ({ ...prev, profilePicture: null }));
//                         setPreviewImage(null);
//                       }}
//                       className="text-red-500 hover:text-red-700 text-sm"
//                     >
//                       Remove Photo
//                     </button>
//                   )}
//                   <p className="text-xs text-gray-500">Maximum size: 5MB</p>
//                 </div>
//               </div>
//               {errors.profilePicture && <p className="mt-2 text-sm text-red-500">{errors.profilePicture}</p>}
//             </div>
//           </div>

//           {/* Organization Details */}
//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//             <div className="flex items-center gap-2 mb-6">
//               <div className="bg-red-100 p-2 rounded-lg">
//                 <Building className="h-5 w-5 text-red-600" />
//               </div>
//               <h3 className="text-lg font-semibold text-gray-900">Organization Details</h3>
//             </div>
            
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//               {/* Role */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Role <span className="text-red-500">*</span>
//                 </label>
//                 <select
//                   name="customRoleId"
//                   value={formData.customRoleId}
//                   onChange={handleChange}
//                   className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
//                     errors.customRoleId ? 'border-red-500' : 'border-gray-300'
//                   }`}
//                 >
//                   <option value="">Select Role</option>
//                   {roles.map(role => (
//                     <option key={role._id} value={role._id}>
//                       {role.roleName}
//                     </option>
//                   ))}
//                 </select>
//                 {errors.customRoleId && <p className="mt-1 text-sm text-red-500">{errors.customRoleId}</p>}
//               </div>

//               {/* Department */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Department <span className="text-red-500">*</span>
//                 </label>
//                 <div className="relative">
//                   <Building className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
//                   <select
//                     name="departmentId"
//                     value={formData.departmentId}
//                     onChange={handleChange}
//                     className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
//                       errors.departmentId ? 'border-red-500' : 'border-gray-300'
//                     }`}
//                   >
//                     <option value="">Select Department</option>
//                     {departments.map(dept => (
//                       <option key={dept._id} value={dept._id}>
//                         {dept.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 {errors.departmentId && <p className="mt-1 text-sm text-red-500">{errors.departmentId}</p>}
//               </div>

//               {/* Division */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Division
//                 </label>
//                 <div className="relative">
//                   <Briefcase className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
//                   <select
//                     name="divisionId"
//                     value={formData.divisionId}
//                     onChange={handleChange}
//                     disabled={!formData.departmentId}
//                     className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
//                   >
//                     <option value="">Select Division</option>
//                     {filteredDivisions.map(div => (
//                       <option key={div._id} value={div._id}>
//                         {div.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Address Information */}
//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//             <div className="flex items-center gap-2 mb-6">
//               <div className="bg-red-100 p-2 rounded-lg">
//                 <MapPin className="h-5 w-5 text-red-600" />
//               </div>
//               <h3 className="text-lg font-semibold text-gray-900">Address Information</h3>
//             </div>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {/* Street */}
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Street Address
//                 </label>
//                 <input
//                   type="text"
//                   name="address.street"
//                   value={formData.address.street}
//                   onChange={handleChange}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//                   placeholder="123 Main Street"
//                 />
//               </div>

//               {/* City */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   City
//                 </label>
//                 <input
//                   type="text"
//                   name="address.city"
//                   value={formData.address.city}
//                   onChange={handleChange}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//                   placeholder="New York"
//                 />
//               </div>

//               {/* State */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   State
//                 </label>
//                 <input
//                   type="text"
//                   name="address.state"
//                   value={formData.address.state}
//                   onChange={handleChange}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//                   placeholder="NY"
//                 />
//               </div>

//               {/* Country */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Country
//                 </label>
//                 <input
//                   type="text"
//                   name="address.country"
//                   value={formData.address.country}
//                   onChange={handleChange}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//                   placeholder="United States"
//                 />
//               </div>

//               {/* Zip Code */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Zip Code
//                 </label>
//                 <input
//                   type="text"
//                   name="address.zipCode"
//                   value={formData.address.zipCode}
//                   onChange={handleChange}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//                   placeholder="10001"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Form Actions */}
//           <div className="flex flex-col sm:flex-row gap-4 justify-end pt-6">
//             <button
//               type="button"
//               onClick={handleCancel}
//               className="w-full sm:w-auto px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
//             >
//               Cancel
//             </button>
//             <button
//               type="button"
//               onClick={resetForm}
//               className="w-full sm:w-auto px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
//             >
//               Reset Form
//             </button>
//             <button
//               type="submit"
//               disabled={isSubmitting}
//               className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-red-600 to-pink-600 text-white rounded-lg hover:from-red-700 hover:to-pink-700 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transition-all transform hover:scale-105 shadow-lg"
//             >
//               {isSubmitting ? (
//                 <>
//                   <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   Sending Invitation...
//                 </>
//               ) : (
//                 <>
//                   <UserPlus className="h-5 w-5" />
//                   Send Invitation
//                 </>
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default InviteUserForm;


// pages/InviteUserPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cropper from "react-easy-crop";
import imageCompression from "browser-image-compression";
import { UserPlus, Mail,  Building,  MapPin, Camera, X, Upload } from 'lucide-react';
import { Country, State, City } from 'country-state-city';
import api from '../../common/apiClient';
import SummaryApi from '../../common/SummaryApi';
import SelectDropdown from '../../customStyles/SelectDropdown';
import CustomDatePicker from '../../customStyles/CustomDatePicker';
import validateForm from '../../helpers/validateForm';
import CroppedImage from '../../helpers/cropImage';
import InviteUserFormSkeleton from '../SkeletonComponents/InviteUserFormSkeleton';

const InviteUserForm = () => {
  const navigate = useNavigate();
  const { portalName } = useParams();
  
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    mobile: '',
    dob: null,
    doj: null,
    customRoleId: '',
    departmentId: '',
    divisionId: '',
    profilePicture: null,
    address: {
      street: '',
      city: '',
      state: '',
      country: '',
      postalCode: ''
    }
  });
  
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  
  // Dropdown data
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  
  // Image handling states
  const [profilePictureFile, setProfilePictureFile] = useState(null);
  const [profilePreview, setProfilePreview] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // Fetch dropdown data on mount
  useEffect(() => {
    fetchDropdownData();
    loadCountries();
  }, []);

  const fetchDropdownData = async () => {
    try {
      const [rolesRes, departmentsRes, divisionsRes] = await Promise.all([
        api.get(SummaryApi.getAllRoles.url),
        api.get(SummaryApi.getAllDepartments.url),
        api.get(SummaryApi.getAllDivisions.url)
      ]);

      const rolesData = rolesRes.data.data || [];
      setRoles(rolesData);
      
      // Set default role if available
      const defaultRole = rolesData.find(role => role.isDefault);
      if (defaultRole) {
        setFormData(prev => ({ ...prev, customRoleId: defaultRole._id }));
      }
      
      setDepartments(departmentsRes.data.data || []);
      setDivisions(divisionsRes.data.data || []);
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
      toast.error('Failed to load form data');
    } finally {
      setLoading(false);
    }
  };

  const loadCountries = () => {
    const allCountries = Country.getAllCountries().map(country => ({
      isoCode: country.isoCode,
      name: country.name,
      flag: country.flag,
      phonecode: country.phonecode
    }));
    setCountries(allCountries);
  };

  // Handle country change
  const handleCountryChange = (countryCode) => {
    setFormData(prev => ({
      ...prev,
      address: {
        ...prev.address,
        country: countryCode,
        state: "",
        city: ""
      }
    }));
    
    if (countryCode) {
      const countryStates = State.getStatesOfCountry(countryCode).map(state => ({
        isoCode: state.isoCode,
        name: state.name,
        countryCode: state.countryCode
      }));
      setStates(countryStates);
      setCities([]);
    } else {
      setStates([]);
      setCities([]);
    }
  };

  // Handle state change
  const handleStateChange = (stateCode) => {
    setFormData(prev => ({
      ...prev,
      address: {
        ...prev.address,
        state: stateCode,
        city: ""
      }
    }));
    
    if (formData.address.country && stateCode) {
      const stateCities = City.getCitiesOfState(formData.address.country, stateCode).map(city => ({
        name: city.name,
        stateCode: city.stateCode,
        countryCode: city.countryCode
      }));
      setCities(stateCities);
    } else {
      setCities([]);
    }
  };

  // Handle city change
  const handleCityChange = (cityName) => {
    setFormData(prev => ({
      ...prev,
      address: {
        ...prev.address,
        city: cityName
      }
    }));
  };

  // Validation configuration
  const validationConfig = {
    requiredFields: ["firstName", "lastName", "email", "customRoleId"],
    patternRules: {
      mobile: {
        pattern: /^[0-9]{10}$/,
        message: "Mobile number must be 10 digits",
      },
      email: {
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Invalid email format",
      }
    }
  };

  // Compress image function
  const compressImage = async (file) => {
    try {
      if (file.size <= 2 * 1024 * 1024) {
        return file;
      }

      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      
      const compressedFile = await imageCompression(file, options);
      return new File([compressedFile], file.name, { type: compressedFile.type });
    } catch (error) {
      console.error('Error compressing image:', error);
      toast.error('Failed to compress image');
      return file;
    }
  };

  // Crop completion handler
  const onCropComplete = (croppedArea, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  };

  // Handle file selection
  const handleFileSelection = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.match("image.*")) {
      toast.error("Please select an image file");
      return;
    }

    const loadingToast = toast.loading('Processing image...');

    try {
      const compressedFile = await compressImage(file);
      
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
        setShowCropper(true);
        toast.dismiss(loadingToast);
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      toast.update(loadingToast, {
        render: 'Failed to process image',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  // Crop image
  const cropImageNow = async () => {
    try {
      const { file, fileUrl } = await CroppedImage(imageSrc, croppedAreaPixels);
      const finalFile = await compressImage(file);
      
      setProfilePictureFile(finalFile);
      setProfilePreview(fileUrl);
      setShowCropper(false);
      setImageSrc(null);
      
      toast.success(`Profile picture added (${(finalFile.size / 1024 / 1024).toFixed(1)}MB)`);
    } catch (e) {
      console.error(e);
      toast.error("Error cropping image");
    }
  };

  // Remove profile picture
  const removeProfilePicture = () => {
    setProfilePreview(null);
    setProfilePictureFile(null);
    toast.info('Profile picture removed');
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const errors = validateForm(formData, validationConfig);
    
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      toast.error("Please fill in all required fields");
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const formDataToSend = new FormData();
      
      // Append basic fields
      formDataToSend.append("firstName", formData.firstName);
      formDataToSend.append("lastName", formData.lastName);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("mobile", formData.mobile);
      formDataToSend.append("role", "custom");
      formDataToSend.append("customRoleId", formData.customRoleId);
      
      if (formData.departmentId) {
        formDataToSend.append("departmentId", formData.departmentId);
      }
      if (formData.divisionId) {
        formDataToSend.append("divisionId", formData.divisionId);
      }
      
      // Append dates
      if (formData.doj) {
        formDataToSend.append("doj", formData.doj);
      }
      if (formData.dob) {
        formDataToSend.append("dob", formData.dob);
      }
      
      // Convert ISO codes to full names before sending
      const addressToSend = {
        ...formData.address,
        country: formData.address.country ? 
          countries.find(c => c.isoCode === formData.address.country)?.name || formData.address.country : "",
        state: formData.address.state ? 
          states.find(s => s.isoCode === formData.address.state)?.name || formData.address.state : "",
        city: formData.address.city || "",
        postalCode: formData.address.postalCode || ""
      };
      formDataToSend.append("address", JSON.stringify(addressToSend));
      
      // Append profile picture if exists
      if (profilePictureFile instanceof File) {
        formDataToSend.append("profilePicture", profilePictureFile);
      }
      
      const response = await api.post(SummaryApi.createInvite.url, formDataToSend);
      
      if (response.data.success) {
        toast.success('Invitation sent successfully!');
        navigate(`/${portalName}/invitations`);
      } else {
        throw new Error(response.data.message || 'Failed to send invitation');
      }
    } catch (error) {
      setErrors({ submit: error.response?.data?.message || error.message });
      toast.error(error.response?.data?.message || 'Failed to send invitation');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      email: '',
      firstName: '',
      lastName: '',
      mobile: '',
      dob: null,
      doj: null,
      customRoleId: '',
      departmentId: '',
      divisionId: '',
      profilePicture: null,
      address: {
        street: '',
        city: '',
        state: '',
        country: '',
        postalCode: ''
      }
    });
    setProfilePreview(null);
    setProfilePictureFile(null);
    setErrors({});
    setStates([]);
    setCities([]);
    
    // Reset to default role
    const defaultRole = roles.find(role => role.isDefault);
    if (defaultRole) {
      setFormData(prev => ({ ...prev, customRoleId: defaultRole._id }));
    }
  };

  // Filter divisions based on department
  const filteredDivisions = formData.departmentId 
    ? divisions.filter(div => div.departmentId === formData.departmentId)
    : divisions;


  const handleCancel = () => {
    navigate(`/${portalName}/invitations`);
  };

  // Clean up object URLs
  useEffect(() => {
    return () => {
      if (profilePreview && profilePreview.startsWith('blob:')) {
        URL.revokeObjectURL(profilePreview);
      }
    };
  }, [profilePreview]);

  if (loading) {
    return <InviteUserFormSkeleton />;
  }

  return (
    <div className="">
      <div className="">
        {/* Header */}
        <div className="bg-gradient-to-r from-red-600 to-red-600 px-6 py-2">
          <div className="flex justify-between items-center">
            <div className="flex-1">
              <h1 className="text-2xl font-bold text-white flex items-center gap-3">
                Invite Team Member
              </h1>
              <p className="text-blue-100">Send an invitation to add a new member to your team</p>
            </div>
                <button
                onClick={() => navigate(-1)}
                className="text-white hover:text-blue-100 transition-colors"
                title="Go back"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
        </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6 p-4">
          {errors.submit && (
            <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg flex items-center">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              {errors.submit}
            </div>
          )}

          {/* Basic Information */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center gap-2 mb-6">
              <div className="bg-red-100 p-2 rounded-lg">
                <Mail className="h-5 w-5 text-red-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Basic Information</h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* First Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  First Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={formData.firstName}
                  onChange={(e) => setFormData(prev => ({ ...prev, firstName: e.target.value }))}
                  className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
                    errors.firstName ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="Enter First Name"
                />
                {errors.firstName && <p className="mt-1 text-sm text-red-500">{errors.firstName}</p>}
              </div>

              {/* Last Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Last Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={formData.lastName}
                  onChange={(e) => setFormData(prev => ({ ...prev, lastName: e.target.value }))}
                  className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
                    errors.lastName ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="Enter Last Name"
                />
                {errors.lastName && <p className="mt-1 text-sm text-red-500">{errors.lastName}</p>}
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
                  className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
                    errors.email ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="user@example.com"
                />
                {errors.email && <p className="mt-1 text-sm text-red-500">{errors.email}</p>}
              </div>

              {/* Mobile */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Mobile Number
                </label>
                <input
                  type="tel"
                  value={formData.mobile}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                    setFormData(prev => ({ ...prev, mobile: value }));
                  }}
                  className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
                    errors.mobile ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="9876543210"
                  maxLength={10}
                />
                {errors.mobile && <p className="mt-1 text-sm text-red-500">{errors.mobile}</p>}
              </div>

              {/* Date of Birth */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Date of Birth
                </label>
                <CustomDatePicker
                  value={formData.dob}
                  onChange={(date) => setFormData(prev => ({ ...prev, dob: date }))}
                  placeholder="Select date"
                  maxDate={new Date()}
                />
              </div>

              {/* Date of Joining */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Date of Joining
                </label>
                <CustomDatePicker
                  value={formData.doj}
                  onChange={(date) => setFormData(prev => ({ ...prev, doj: date }))}
                  placeholder="Select date"
                />
              </div>
            </div>

            {/* Profile Picture Section */}
            <div className="mt-8 pt-6 border-t">
              <h4 className="text-sm font-medium text-gray-700 mb-4">Profile Picture (Optional)</h4>
              
              {/* Preview Section */}
              {profilePreview && (
                <div className="flex justify-center mb-6">
                  <div className="relative group">
                    <img
                      src={profilePreview}
                      alt="Profile Preview"
                      className="w-32 h-32 rounded-full object-cover border-4 border-red-100"
                    />
                    <button
                      type="button"
                      onClick={removeProfilePicture}
                      className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              )}

              {showCropper ? (
                <div className="bg-gray-50 p-4 rounded-lg">
                  <div className="relative w-full h-72 sm:h-96 bg-black rounded-lg overflow-hidden">
                    <Cropper
                      image={imageSrc}
                      crop={crop}
                      zoom={zoom}
                      aspect={1}
                      onCropChange={setCrop}
                      onZoomChange={setZoom}
                      onCropComplete={onCropComplete}
                    />
                  </div>

                  <div className="flex items-center gap-4 mt-4">
                    <label className="text-sm font-medium">Zoom:</label>
                    <input
                      type="range"
                      min={1}
                      max={3}
                      step={0.1}
                      value={zoom}
                      onChange={(e) => setZoom(parseFloat(e.target.value))}
                      className="w-full"
                    />
                  </div>

                  <div className="flex justify-between mt-6">
                    <button
                      type="button"
                      onClick={() => {
                        setShowCropper(false);
                        setImageSrc(null);
                      }}
                      className="flex items-center gap-1 text-gray-500 hover:text-gray-700"
                    >
                      <X className="w-4 h-4" /> Cancel
                    </button>
                    <button
                      type="button"
                      onClick={cropImageNow}
                      className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
                    >
                      Crop & Use
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  {/* Upload from Gallery */}
                  <label className="cursor-pointer">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileSelection}
                      className="hidden"
                    />
                    <div className="flex items-center justify-center gap-2 bg-red-50 hover:bg-red-100 text-red-700 py-2 px-4 rounded-lg transition-colors">
                      <Upload className="w-5 h-5" />
                      <span>Upload Image</span>
                    </div>
                  </label>

                  {/* Use Camera */}
                  <label className="cursor-pointer">
                    <input
                      type="file"
                      accept="image/*"
                      capture="user"
                      onChange={handleFileSelection}
                      className="hidden"
                    />
                    <div className="flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-lg transition-colors">
                      <Camera className="w-5 h-5" />
                      <span>Use Camera</span>
                    </div>
                  </label>
                </div>
              )}

              {!showCropper && !profilePreview && (
                <div className="text-center text-xs text-gray-500 mt-3">
                  Images larger than 2MB will be automatically compressed
                </div>
              )}
            </div>
          </div>

          {/* Organization Details */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center gap-2 mb-6">
              <div className="bg-red-100 p-2 rounded-lg">
                <Building className="h-5 w-5 text-red-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Organization Details</h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Role */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Role <span className="text-red-500">*</span>
                </label>
                <SelectDropdown
                  options={roles}
                  value={formData.customRoleId}
                  onChange={(value) => setFormData(prev => ({ ...prev, customRoleId: value }))}
                  placeholder="Select Role"
                  valueKey="_id"
                  labelKey="roleName"
                  error={errors.customRoleId}
                />
                {errors.customRoleId && <p className="mt-1 text-sm text-red-500">{errors.customRoleId}</p>}
              </div>

              {/* Department */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Department
                </label>
                <SelectDropdown
                  options={departments}
                  value={formData.departmentId}
                  onChange={(value) => setFormData(prev => ({ ...prev, departmentId: value }))}
                  placeholder="Select Department"
                  valueKey="_id"
                  labelKey="name"
                />
              </div>

              {/* Division */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Division
                </label>
                <SelectDropdown
                  options={filteredDivisions}
                  value={formData.divisionId}
                  onChange={(value) => setFormData(prev => ({ ...prev, divisionId: value }))}
                  placeholder={formData.departmentId ? "Select Division" : "Select Department First"}
                  valueKey="_id"
                  labelKey="name"
                  disabled={!formData.departmentId}
                />
              </div>
            </div>
          </div>

          {/* Address Information */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center gap-2 mb-6">
              <div className="bg-red-100 p-2 rounded-lg">
                <MapPin className="h-5 w-5 text-red-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Address Information</h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Street */}
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Street Address
                </label>
                <input
                  type="text"
                  value={formData.address.street}
                  onChange={(e) => setFormData(prev => ({ 
                    ...prev, 
                    address: { ...prev.address, street: e.target.value }
                  }))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  placeholder="Enter Street Address"
                />
              </div>

              {/* Country */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Country
                </label>
                <SelectDropdown
                  options={countries}
                  value={formData.address.country}
                  onChange={handleCountryChange}
                  placeholder="Select Country"
                  valueKey="isoCode"
                  labelKey="name"
                  searchable={true}
                />
              </div>

              {/* State */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  State
                </label>
                <SelectDropdown
                  options={states}
                  value={formData.address.state}
                  onChange={handleStateChange}
                  placeholder={formData.address.country ? "Select State" : "Select Country First"}
                  valueKey="isoCode"
                  labelKey="name"
                  disabled={!formData.address.country}
                  searchable={true}
                />
              </div>

              {/* City */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  City
                </label>
                <SelectDropdown
                  options={cities}
                  value={formData.address.city}
                  onChange={handleCityChange}
                  placeholder={formData.address.state ? "Select City" : "Select State First"}
                  valueKey="name"
                  labelKey="name"
                  disabled={!formData.address.state}
                  searchable={true}
                />
              </div>

              {/* Postal Code */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Postal Code
                </label>
                <input
                  type="text"
                  value={formData.address.postalCode}
                  onChange={(e) => setFormData(prev => ({ 
                    ...prev, 
                    address: { ...prev.address, postalCode: e.target.value }
                  }))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  placeholder="Enter Postal Code"
                />
              </div>
            </div>
          </div>

          {/* Form Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-end pt-6">
            <button
              type="button"
              onClick={handleCancel}
              className="w-full sm:w-auto px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={resetForm}
              className="w-full sm:w-auto px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
            >
              Reset Form
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-red-600 to-pink-600 text-white rounded-lg hover:from-red-700 hover:to-pink-700 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transition-all transform hover:scale-105 shadow-lg"
            >
              {isSubmitting ? (
                <>
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Sending Invitation...
                </>
              ) : (
                <>
                  <UserPlus className="h-5 w-5" />
                  Send Invitation
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InviteUserForm;
